<template>
  <div>
    <hero-parallax
      :src="hero.image.large"
      :compact-src="hero.image.medium"
      :alt="hero.image.alt"
      :title="hero.headline"
      :motto="hero.subheadline"
      :loading="loading"
      :failed="failed"
    />
    <main class="pentagon-home-main">
      <mdb-container>
        <!--Grid row-->
        <mdb-row class="py-5" center>
          <!--Grid column-->
          <mdb-col md="8" sm="12">
            <h2 class="pentagon-intro-title text-center">{{ $t('home.membership_heading') }}</h2>
<!--            <p>-->
<!--
  Is jouw eindexamen reis je door de neus geboord door Corona? Het feit dat je
  vakantie hebt sinds mei nutteloos omdat je toch niet uit kon gaan?
-->
<!--            </p>-->
<!--            <p>-->
<!--
  Erachter gekomen dat de studievereniging niet genoeg sociale activiteiten heeft nu
  het fysieke studeren wegvalt?
-->
<!--            </p>-->
<!--            <p>-->
<!--
  De komende 5 jaar heb je de kans om dit allemaal in te halen! Hoe dan, hoor ik je al
  denken. Door je in te schrijven bij ons dispuut!
-->
<!--            </p>-->
            <p>
              {{ $t('home.introduction_one') }}
            </p>
            <p>
              {{ $t('home.introduction_two') }}
            </p>
            <p>
              {{ $t('home.introduction_three') }}
            </p>
          </mdb-col>

          <mdb-col md="6" class="text-center">
            <mdb-btn
              tag="a"
              floating
              class="pentagon-social pentagon-social--crimson"
              href="https://www.instagram.com/pentagon.amsterdam/"
              target="_blank"
              rel="noopener"
              :aria-label="$t('social.instagram')"
            >
              <mdb-icon fab icon="instagram" size="2x" />
            </mdb-btn>
          </mdb-col>

          <mdb-col md="6" class="text-center">
            <mdb-btn
              tag="a"
              floating
              class="pentagon-social pentagon-social--forest"
              href="https://www.facebook.com/pentagonamsterdam"
              target="_blank"
              rel="noopener"
              :aria-label="$t('social.facebook')"
            >
              <mdb-icon fab icon="facebook-f" size="2x" />
            </mdb-btn>
          </mdb-col>
          <!--Grid column-->
        </mdb-row>
        <!--Grid row-->

<!--        &lt;!&ndash;Grid row&ndash;&gt;-->
<!--        <mdb-row class="py-5">-->
<!--          &lt;!&ndash;Grid column&ndash;&gt;-->
<!--          <mdb-col md="12">-->
<!--            <p>-->
<!--
  Het Amsterdamsch Heerendispuut P.E.N.T.A.G.O.N. is gelieerd aan studentenvereniging
  Nomen Non Magnum Est, kortweg NoNoMes, te Amsterdam. P.E.N.T.A.G.O.N. is opgericht
  in 1989.
-->
<!--            </p>-->
<!--            <p>-->
<!--
  Een vast patroon van tradities en gedeelde waarden, tezamen met het jaarlijks
  verwelkomen van nieuwe persoonlijkheden heeft ertoe geleid dat P.E.N.T.A.G.O.N. zich
  kan kenmerken met een uniek en divers actief ledenbestand. Het grote aantal actieve
  reünisten laat zien dat een dispuut voor een P.E.N.T.A.G.O.N-ees meer betekent dan
  een kortstondig feestmoment.
-->
<!--            </p>-->
<!--            <p>-->
<!--
  Daar waar het lijkt alsof het Amsterdamse studentenleven elk jaar curieuzere vormen
  kan aannemen, geldt de dinsdagavond voor de leden als emotionele houvast in de week.
  Na de vaste borrel in stamkroeg de Heffer, wordt deze avond tot in de vroege uurtjes
  voortgezet in de sociëteit De Heilige Zeug. Door de jaren heen heeft het dispuut een
  vast repertoire van Amsterdamse kroegen en cafés eigen gemaakt, waar de leden op de
  andere doordeweekse avonden en in het weekend te vinden zijn.
-->
<!--            </p>-->
<!--            <p>-->
<!--
  Vaste activiteiten als diners, gala's, weekenden weg, hockeytoernooien en vakanties
  zorgen ervoor dat een lidmaatschap bij P.E.N.T.A.G.O.N. garant staat voor
  levenslange vriendschappen en onvergetelijke herinneringen aan een prachtig
  Amsterdams studentenleven.
-->
<!--            </p>-->
<!--          </mdb-col>-->
<!--          &lt;!&ndash;Grid column&ndash;&gt;-->
<!--        </mdb-row>-->
<!--        &lt;!&ndash;Grid row&ndash;&gt;-->
      </mdb-container>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  mdbContainer, mdbRow, mdbCol, mdbBtn, mdbIcon,
} from 'mdbvue';
import HeroParallax from '../components/HeroParallax.vue';

export default {
  name: 'home',
  components: {
    HeroParallax,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbIcon,
  },
  computed: {
    ...mapGetters('intro', ['hero']),
    ...mapState('intro', { loading: 'loading', failed: 'error' }),
  },
  created() {
    this.$store.commit('TOGGLE_ON_NAVBAR_TRANSPARENT');
    this.$store.dispatch('intro/fetchSite');
  },
};
</script>

<style lang="scss">
// The introduction overlaps the hero's lower edge and rises into place.
.pentagon-home-main {
  top: 0;
  margin-top: -6rem;
  animation: intro-rise 900ms 300ms ease-out both;
}

.pentagon-intro-title {
  margin-bottom: 1.5rem;
  font-size: clamp(1.4rem, 4vw, 2.4rem);
}

.pentagon-social.btn-floating {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: 1px solid rgba(255, 215, 0, 0.45);
  border-radius: 50%;
  color: var(--pentagon-ivory);
  line-height: 1;

  // MDB gives the icon a fixed 40px line height, which pushes it to the top of the circle.
  i {
    width: auto;
    color: var(--pentagon-ivory);
    line-height: 1;
  }

  &:hover {
    color: var(--pentagon-gold);
  }

}

.pentagon-social--crimson.btn-floating {
  background-color: var(--pentagon-crimson) !important;
}

.pentagon-social--forest.btn-floating {
  background-color: var(--pentagon-forest) !important;
}

@keyframes intro-rise {
  from {
    opacity: 0;
    transform: translateY(24px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .pentagon-home-main {
    animation: none;
  }
}
</style>
